/*****************
 * GA4
 */

dataLayer.push({ecommerce: null});
dataLayer.push({
    event: "view_item_list",
    ecommerce: {
        currency: Shopify.currency.active,
        item_list_id: collection.id,
        item_list_name: collection.title,
        items: collection.products.map(function (item, index) {
            return {
                item_id: item.id,
                item_name: item.title,
                item_variant: item.variants[0].title,
                item_category: item.type,
                quantity: 1,
                index: index,
                item_list_id: collection.id,
                item_list_name: collection.title,
                price: item.price / 100
            }
        })
    }
});

/********************
 * Collection Sorting
 ********************/

document.querySelector('.collectionSortingInner')?.addEventListener('click', function () {
    this.classList.toggle('active');
})

document.querySelectorAll('.collectionSortingItemInput')?.forEach(input => {
    input.addEventListener('change', function () {
        if (this.parentElement.classList.contains('active')) {
            this.value = "";
        }
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value || 'manual');
        window.location.href = url.toString();
    })
})

/********************
 * Collection Dialog
 ********************/

const collectionDialog = document.querySelector('.collectionFilters');

document.querySelector('.collectionFilterButton')?.addEventListener('click', function () {
    if (!collectionDialog) return;
    collectionDialog.showModal();
    document.querySelector("body").classList.add("noScroll");
})

// close on clicking outside of main container
collectionDialog?.addEventListener('click', function (e) {
    if (e.target === this) {
        this.close();
        document.querySelector("body").classList.remove("noScroll");
    }
})

// close on modal exit buttons
collectionDialog?.querySelector('.collectionFiltersExit')?.addEventListener('click', () => {
    collectionDialog.close();
    document.querySelector("body").classList.remove("noScroll");
})

// on close event remove noScroll on body
collectionDialog?.addEventListener('close', () => {
    document.querySelector("body").classList.remove("noScroll");
})

/*****************
 * Price Filtering
 *****************/

// using inputs to set price search
document.querySelector('#collectionFiltersOptionsItemValuesPriceButton')?.addEventListener('click', function () {
    let min = document.querySelector('#collectionFiltersOptionsItemValuesPriceInputMin').value;
    let max = document.querySelector('#collectionFiltersOptionsItemValuesPriceInputMax').value;
    let url = new URL(window.location.href);
    url.searchParams.set('filter.v.price.gte', min);
    url.searchParams.set('filter.v.price.lte', max);
    window.location.href = url;
});

// on load see if there is a price filter, then add a removal button to active filters
if (window.location.search.includes('filter.v.price.gte') && document.querySelector('.collectionFiltersClear')) {
    // get info for displaying the price filter
    const min = new URLSearchParams(window.location.search).get('filter.v.price.gte');
    const max = new URLSearchParams(window.location.search).get('filter.v.price.lte');
    const paramButton = document.createElement('button');
    paramButton.classList.add('collectionFiltersClearPrice', 'collectionFiltersClear', 'collectionFiltersContentBottomButton');
    paramButton.textContent = `Clear Price Filter: ${min} - ${max}`;

    // show clear filters button and add the price filter button
    document.querySelector('.collectionFiltersClear').classList.add('active');
    document.querySelector('.collectionFiltersClear').insertAdjacentElement('beforebegin', paramButton);
}

// if button is added, use to remove only price as a filter
document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.collectionFiltersClearPrice')?.addEventListener('click', function () {
        // Create a new URL object and get access to params
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        // delete the price filters
        params.delete('filter.v.price.gte');
        params.delete('filter.v.price.lte');
        // Create a new URL object with the modified parameters to clear the price filter
        window.location.href = new URL(url.origin + url.pathname + '?' + params.toString());
    })
})

/*****************
 * Other Filters
 *****************/

document.querySelector('.collectionFiltersActivate')?.addEventListener('click', function () {
    console.log("click")
    let searchURL = document.querySelector('.collectionFiltersContent').dataset.base + "?";
    document.querySelectorAll('.collectionFiltersOptionsItemValuesLinkInput:checked')?.forEach((input, index) => {
        console.log(input.value)
        if (index === 0) {
            searchURL += input.value
        } else {
            searchURL += "&" + input.value
        }
    });
    console.log(searchURL)
    window.location.href = searchURL;
})


